import constants from "../constants/Feedback/validationAutomata";

const isValidMachine = (dot) => {
  //verifica se a máquina apresenta apenas 1 estado inicial
  // let startVertex = "";
  // let valid = false;
  // let validationError = 2; //falta de estado inicial
  let status = {
    startVertex: "",
    valid: false,
    validationError: 2,
    message: constants.validMachine.error.missState,
  };
  if (dot) {
    try {
      const states = dot.split("\n\n")[0].split("\n");
      let importantStates = dot.split("\n\n")[2];
      if (importantStates != undefined) {
        importantStates = importantStates.split("\n");
        for (let i = 0; i < importantStates.length - 1; i++) {
          let arrayTypeState = importantStates[i];
          const typeState = arrayTypeState.split("shape=")[1].split("]")[0];
          if (typeState == "Mdiamond" || typeState == "diamond") {
            if (status.startVertex == "") {
              status.startVertex = arrayTypeState
                .split("shape=")[0]
                .split("[")[0];
              status.valid = true;
              status.message = constants.validMachine.success.valid;
            } else {
              status.valid = false;
              status.validationError = 3;
              status.message =
                constants.validMachine.error.multiplesInitialStates;
            }
          }
        }
      }
      if (status.startVertex === "") {
        status.valid = false;
        status.message = constants.validMachine.error.missInitialState;
      }
      if (states.splice(0, 1).length === 0) {
        status.validationError = 1;
        status.message = constants.validMachine.error.missState;
      }

      // for (let state of states) {
      //   // const typeState = state;
      //   if (state.initial === true) {
      //     if (status.startVertex === "") {
      //       status.startVertex = state.text;
      //       status.valid = true;
      //       status.message = constants.validMachine.success.valid;
      //     } else {
      //       status.valid = false;
      //       status.validationError = 3;
      //       status.message = constants.validMachine.error.multiplesInitialStates;
      //     }
      //   }
      // }
      // if (status.startVertex === "") {
      //   status.valid = false;
      //   status.message = constants.validMachine.error.missInitialState;
      // }
      // if (states.length === 0) {
      //   status.validationError = 1;
      //   status.message = constants.validMachine.error.missState;
      // }
      return status;
    } catch (e) {
      alert(e);
    }
  }
  return status;
};

export default { isValidMachine };
